import React from "react";
import { CiCalendarDate } from "react-icons/ci";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import { urlFor } from "../client";

const NewsCard = ({ blog, setSingleBlog }) => {
  const navigation = useNavigate();

  const handleNavigate = () => {
    setSingleBlog(blog);
    navigation("/single-blog");
  };

  return (
    <div className="newsCard" onClick={() => handleNavigate()}>
      <img src={urlFor(blog.blogimg)} alt="" />

      <div className="footer">
        <div>
          <CiCalendarDate className="io" />
          <small>{blog.dop}</small>
        </div>
        <div>
          <HiOutlineLocationMarker className="io" />
          <small>{blog.location}</small>
        </div>
      </div>

      <h1 className="heading">{blog.title}</h1>
      <p>{blog.shortDesc}</p>
    </div>
  );
};

export default NewsCard;
